<template>
  <v-card outlined class="rounded-lg mb-2 mt-1">
    <h3 class="mt-3 ml-3">
      {{ $t('messages.describe_reason_not_captured') }} {{ labelTipo }}<span style="color: red">*</span>
    </h3>
    <v-form ref="reasonForm">
      <v-row dense class="pt-4 pr-3 pl-3">
        <v-col cols="12">
          <v-select
          
            class="rounded-lg"
            color="#086318"
            v-model="captationsForm.reasonsForNotCaptureId"
            :rules="formRules"
            :items="reasonsForNotCapture"
            item-text="description"
            item-value="description"
            outlined
            dense
          >
            <template v-slot:label>
              {{ $t('inputs.captations.reason_not_captured') }}
              <span style="color: red">*</span>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" v-if="isFamilyWithdrawal">
          <v-textarea
            class="rounded-lg"
            color="#086318"
            v-model="captationsForm.family_reason_description"
            :rules="formRules"
            dense
            outlined
          >
            <template v-slot:label>
              {{ $t('inputs.captations.reason_for_withdrawal') }} <span style="color: red;">*</span>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
export default {
  props: {
    captationsForm: { type: Object, required: true },
    reasonsForNotCapture: { type: Array, default: () => [] },
    formRules: { type: Array, required: true },
    realized: { type: String, default: "" },
    clearValidation: { type: Boolean, default: false },
  },
 
  computed: {
    labelTipo() {
      return this.realized === 'captou-apenas-orgaos' ? 'tecidos' : 'orgãos';
    },

    isFamilyWithdrawal() {
      return this.captationsForm.reasonsForNotCaptureId === 'Desistência Familiar';
    },
  },

  watch: {
    clearValidation: {
      handler(value) {
        if (!value) return;

        this.$nextTick(() => {
          this.$refs.reasonForm?.resetValidation();
          this.$emit('update:clearValidation', false);
        });
      },
    },
  },
};
</script>
